import React from "react";
import { Box } from "@chakra-ui/react";
import Tooltip from "rc-tooltip";
import { useTranslation } from "react-i18next";

type Props = {
	memberCount: number;
	maxStudents: number;
};

export function ClassroomStudentCount({ memberCount, maxStudents }: Props): JSX.Element {
	const { t } = useTranslation();
	if (memberCount > maxStudents) {
		return (
			<Box zIndex="1">
				<Tooltip
					placement="top"
					trigger={["hover"]}
					destroyTooltipOnHide={true}
					overlayClassName="Tooltip"
					overlay={
						<Box>
							{t("overview.exceedsMaxStudentLimit")}
							<br />
							{t("overview.classCannotBeStarted")}
						</Box>
					}
				>
					<Box fontSize="14px" color="#A03B46">
						{t("overview.student", { count: memberCount })}
					</Box>
				</Tooltip>
			</Box>
		);
	}
	return <Box fontSize="14px">{t("overview.student", { count: memberCount })}</Box>;
}
